<script>
export default {
    name: 'BaseTimePickerPicker',
};
</script>

<script setup>
import { computed } from 'vue';
import { TYPE } from '@/components/base-components/components/time-picker/index.js';

const props = defineProps({
    value: {
        type: Number,
    },
    items: {
        type:     Array,
        required: true,
    },
    type:  {
        type:      String,
        default:   TYPE.DEFAULT,
        validator: value => Object.values(TYPE).includes(value),
    },
});

const emit = defineEmits({
    input: null,
});

const model = computed({
    get: () => props.value ?? 0,
    set: value => emit('input', value),
});

const activeClass = computed(() => ({
    [TYPE.DEFAULT]:       'font-semibold text-gray-600',
    [TYPE.PRIMARY]:       'font-semibold text-primary-600',
    [TYPE.SECONDARY]:     'font-semibold text-secondary-950',
    [TYPE.PRIMARY_OLD]:   'font-semibold text-science-blue-500',
    [TYPE.SECONDARY_OLD]: 'font-semibold text-science-blue-800',
    [TYPE.SUCCESS]:       'font-semibold text-emerald-600',
    [TYPE.WARNING]:       'font-semibold text-orange-500',
    [TYPE.DANGER]:        'font-semibold text-red-600',
    [TYPE.INFO]:          'font-semibold text-gray-500',
}[props.type]));
</script>

<template>
    <base-snap-scroll
        v-model="model"
        class="min-w-16"
        :items="items"
        item-wrap-class="flex w-full items-center justify-center"
    >
        <template #item="{ item, active, activate, isScrolling }">
            <div
                v-text="item.label"
                class="z-10 flex h-full w-full select-none items-center justify-center rounded-sm"
                :class="{
                    [activeClass]: active,
                    'cursor-pointer hover:bg-gray-50': !active && !isScrolling,
                }"
                @click="activate"
            />
        </template>
    </base-snap-scroll>
</template>
